// extracted by mini-css-extract-plugin
export default {"filer-content":"Products_filer-content__rRdDO"};